import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FeatureFlagHealthcheckI from './FeatureFlagHealthcheckI';

const initialState: FeatureFlagHealthcheckI = {};

export default createSlice({
  name: 'featureFlagHealthcheck',
  initialState,
  reducers: {
    init: (state, action: PayloadAction<FeatureFlagHealthcheckI>): void => {
      Object.assign(state, action.payload);
    },
  },
});
